import { render } from "./invoiceTable.vue?vue&type=template&id=d87b69c0"
import script from "./invoiceTable.vue?vue&type=script&lang=js"
export * from "./invoiceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__